import { useContext } from "react";
import { FormContext } from "./context";

export const useFormContext = () => {
	const context = useContext(FormContext);
	if (!context) throw new Error("Form compound components cannot be used outside Form component.");
	return context;
};
